import {connect} from 'react-redux';
import Home from './components/';
import {setPageTitle, setBreadCrumb} from '../common/actions';

const mapStateToProps = (state) => {
    return {

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setPageTitle: (value) => {
            dispatch(setPageTitle(value));
        },
        setBreadCrumb: (items) => {
            dispatch(setBreadCrumb(items));
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Home)